module.exports = __webpack_public_path__ + "img/sonido2.bee4109e.jpg";